<template>
  <div v-if="show" class="form-item-component">
      <slot :readOnly="state == 'read'" />
  </div>
</template>


<script>
export default {
  name: "FormItemComponent",
  props: {
    new: {
      type: Boolean,
      required: false,
      default: true
    },
    edit: {
      type: Boolean,
      required: false,
      default: true
    },
    read: {
      type: Boolean,
      required: false,
      default: true
    },
    state: {
      type: String,
      required: true
    }
  },
  computed: {
    show() {
      let value = true;

      if (this.state == "new" && !this.new) {
        value = false;
      } else if (this.state == "edit" && !this.edit) {
        value = false;
      } else if (this.state == "read" && !this.read) {
        value = false;
      }

      return value;
    }
  }
};
</script>
<style scoped>
</style>
